/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { TicketDTO } from "./GetStudentTickets";
interface TicketData {
  TicketData: TicketDTO[];
}

interface TicketResponse {
  data?: TicketData;
  error?: ApiError;
}

export const GetTicketById = async (id: string): Promise<TicketResponse> => {
  try {
    const response = await axios.get(`/support/ticket/${id}`);
    return { data: { TicketData: [response.data] } };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
